const axios = require('axios')

export default new class utils {
  postAPI (url, data) {
    return new Promise(function (resolve, reject) {
      console.log(process.env.VUE_APP_BASE_API)
      axios.post(process.env.VUE_APP_BASE_API + url,
        data,
        {
          headers: {
            'accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('user-token')
          }
        }
      )
        .then((response) => {
          console.log('here is the result', response)
          resolve(response.data)
        })
        .catch((response) => {
          console.log('Error!', response)
          reject(response)
        })
    })
  }
}()
